import { useEffect } from 'react';
import { MenuItemInterface } from './types';

interface Props {
  // Enable or disable the border between menu items.
  border?: boolean;
  // Display object for menu interaction
  children: JSX.Element | undefined;
  // Adds a space between final and previous menu items.
  exclusive?: boolean;
  // unique ID for RaulMenu in order to set items
  id: string;
  // individual menu items to show in dropdown
  items: MenuItemInterface[];
  // Controls visibility of the menu.
  open?: boolean;
  // Menu items text size (sm = 12px, md = 14px).
  textSize?: 'md' | 'sm';
  // Enable or disable text-underline on hover over menu item.
  textUnderline?: boolean;
  // Type of variant for menu look.
  variant?: 'items' | 'links';
}

const RaulMenu = ({
  border = true,
  children,
  exclusive = false,
  id,
  items,
  open = false,
  textSize,
  textUnderline,
  variant = 'links',
}: Props) => {
  // Load Sidebar Navigation Items
  useEffect(() => {
    const actionMenu = document.getElementById(id);

    if (!items || !actionMenu) return;
    // @ts-expect-error: items "does not exist on type"
    actionMenu.items = items;
  }, [id, items]);

  return (
    <raul-menu
      // @ts-expect-error: border & children "does not exist on type"
      // eslint-disable-next-line react/no-children-prop
      children={children}
      border={border}
      exclusive={exclusive}
      id={id}
      open={open}
      text-size={textSize}
      text-underline={textUnderline}
      variant={variant}
    />
  );
};

export default RaulMenu;
